// src/lib/vatStagger.js
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

const MONTH_SHORT = [
  "Jan","Feb","Mar","Apr","May","Jun",
  "Jul","Aug","Sep","Oct","Nov","Dec"
];

function nextMonth(m)  { return m === 12 ? 1 : m + 1; }
function pad(m)        { return String(m).padStart(2, "0"); }
function monthShort(m) { return MONTH_SHORT[m - 1]; }

function getMonthYear(startMonth, quarterIndex, baseYear, monthOffset) {
  let month = startMonth;
  let year  = baseYear;
  for (let i = 0; i < quarterIndex * 3 + monthOffset; i++) {
    month = nextMonth(month);
    if (month === 1) year++;
  }
  return year;
}

/**
 * @param staggerStartMonth  e.g. 11 for November
 * @param deadlineDay        e.g. 28 — day of month after quarter ends
 * @param year               base year to compute from
 */
export function getVatQuarters(
  staggerStartMonth,
  deadlineDay = 28,
  year = dayjs().year()
) {
  const quarters = [];
  let startMonth = staggerStartMonth;

  for (let q = 0; q < 4; q++) {
    const m1 = startMonth;
    const m2 = nextMonth(m1);
    const m3 = nextMonth(m2);
    const deadlineMonth = nextMonth(m3); // month AFTER quarter ends

    const m1Year       = getMonthYear(staggerStartMonth, q, year, 0);
    const m3Year       = getMonthYear(staggerStartMonth, q, year, 2);
    const deadlineYear = getMonthYear(staggerStartMonth, q, year, 3);

    const fromDate = dayjs(`${m1Year}-${pad(m1)}-01`);
    const toDate   = dayjs(`${m3Year}-${pad(m3)}-01`).endOf("month");

    // deadline = deadlineDay of the month after quarter ends
    const deadline = dayjs(
      `${deadlineYear}-${pad(deadlineMonth)}-${pad(deadlineDay)}`
    );

    const today = dayjs();

    let computedStatus;
    if (today.isBefore(toDate))        computedStatus = "upcoming";
    else if (today.isBefore(deadline)) computedStatus = "due";
    else                               computedStatus = "overdue";

    quarters.push({
      quarterNum:    q + 1,
      label:         `Q${q + 1}: ${monthShort(m1)}–${monthShort(m3)}`,
      period:        `${monthShort(m1)} ${m1Year} – ${monthShort(m3)} ${m3Year}`,
      fromDate:      fromDate.format("YYYY-MM-DD"),
      toDate:        toDate.format("YYYY-MM-DD"),
      deadlineDate:  deadline.format("YYYY-MM-DD"),
      deadlineLabel: `${deadlineDay} ${monthShort(deadlineMonth)} ${deadlineYear}`,
      computedStatus,
    });

    startMonth = nextMonth(m3);
  }

  return quarters;
}